import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-fracture-pressure',
    template: `
      <app-pore-and-frac [pressureType]="'fracPressure'" [componentId]="componentId"></app-pore-and-frac>
    `,
    standalone: false
})
export class FracturePressureComponent {
  @Input()
  public componentId: string;
}
